import { type Revision, RevisionPageType } from '../types';
import { getPageComputedSeed } from './ContentComputer';

/**
 * Find the translation a revision renders, when it is a translated space.
 * The seed is what the content computer used to derive the translated page IDs from the source ones.
 */
export function getTranslationDependencyFromRevision(
    revision: Pick<Revision, 'pages'>
): { translationId: string; computedSeed: string } | undefined {
    for (const page of Object.values(revision.pages)) {
        if (
            page.type !== RevisionPageType.Computed ||
            page.computed.type !== 'builtin:translation'
        ) {
            continue;
        }

        const translationDependency = page.computed.dependencies?.translation;
        if (translationDependency?.ref?.kind === 'translation') {
            return {
                translationId: translationDependency.ref.translation,
                computedSeed: getPageComputedSeed(page),
            };
        }
    }

    return undefined;
}
